import { goalProgressMeasurement } from 'shared/constants.json';

export const getParentTreeWithAggregations = (goalIds, { selectSingle, selectMultiple }) => {
  if (goalIds.length === 0) {
    return [];
  }
  const goalParents = selectMultiple(goalIds)
    .filter((g) => g.progressMeasurement !== goalProgressMeasurement.none)
    .map((g) => g.parents)
    .flat();

  const getParentWithAggregation = (res, p) => {
    if (p === undefined) {
      return res;
    }

    const g = selectSingle(p.uid);
    if (g === undefined) {
      return res;
    }
    if (g.progressMeasurement !== goalProgressMeasurement.alignedItems) {
      return res;
    }
    return [...res, ...g.parents.reduce(getParentWithAggregation, [g.uid])];
  };

  return goalParents.reduce((res, next) => getParentWithAggregation(res, next), []);
};
